var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle',_vm._b({},'circle',{
        class : 'tool_svgElem',
        id    : _vm.tool.id + '-body',
        cx    : _vm.tool.coords.pts[0].x, 
        cy    : _vm.tool.coords.pts[0].y,
        r     : _vm.radius
    },false))
}
var staticRenderFns = []

export { render, staticRenderFns }